export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6849.e38b9ea1.jpg";